/* unplugin-vue-components disabled */import script from "./PriceShowBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceShowBlock.vue?vue&type=script&setup=true&lang=ts"

import "./PriceShowBlock.vue?vue&type=style&index=0&id=53d62cc2&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53d62cc2"]])

export default __exports__